// NO SUGAR · Datos nutricionales (metacampos ns_nutri) para los módulos y anillos de macros.
// - NSNutri.get(handle): un platillo (/products/<handle>?view=ns-nutri).
//   Sin encabezado Accept: application/json, porque con él Shopify ignora ?view= y responde su propio JSON.
// - NSNutri.menu(n): todos los platillos de la colección menu<n> (/collections/menu<n>?view=ns-nutri).
// - NSNutri.aros(n, opt): anillos de kcal y macros (mismo dibujo que snippets/ns-macros-anillos.liquid).
// - En la vista rápida de los módulos (evento 'ns:quickview') agrega los anillos y los alérgenos.
(function (global) {
  'use strict';
  var N = {};
  var cache = {}, menus = {};
  var KCAL_DIA = 2000;
  var K_SESSION = 'ns2_nutri_v1';
  // Vocabulario de alérgenos de la web (la avena cuenta como gluten por la NOM-051).
  N.ALERGENOS = ['Gluten', 'Huevo', 'Lácteos', 'Soya', 'Pescado', 'Crustáceos', 'Cacahuate', 'Nueces', 'Ajonjolí', 'Mostaza', 'Apio', 'Sulfitos'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : null; }
  function plano(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
  function fmt(n) { return Math.round(n).toLocaleString('es-MX'); }

  // Los datos del menú se guardan en la sesión del navegador para no pedirlos en cada página.
  function leerSesion() { try { return JSON.parse(global.sessionStorage.getItem(K_SESSION)) || {}; } catch (e) { return {}; } }
  function guardarSesion(k, v) {
    try { var s = leerSesion(); s[k] = { t: Date.now(), v: v }; global.sessionStorage.setItem(K_SESSION, JSON.stringify(s)); } catch (e) { /* opcional */ }
  }

  N.get = function (handle) {
    if (!handle) return Promise.resolve(null);
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=ns-nutri', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  };

  // Mapa { handle: datos } de una colección menu1..menu4. Recorre todas las páginas.
  N.menu = function (n) {
    var key = 'menu' + n;
    if (!menus[key]) {
      var s = leerSesion()[key];
      if (s && s.v && Object.keys(s.v).length && Date.now() - s.t < 30 * 60 * 1000) menus[key] = Promise.resolve(s.v);
      else {
        menus[key] = (async function () {
          var out = {};
          for (var page = 1; page <= 12; page++) {
            var r = await fetch('/collections/' + key + '?view=ns-nutri&page=' + page, { credentials: 'same-origin' });
            if (!r.ok) break;
            var j;
            try { j = await r.json(); } catch (e) { break; } // otra plantilla (p. ej. el tema publicado): sin datos
            if (!j || typeof j !== 'object') break;
            Object.keys(j.items || {}).forEach(function (h) { out[h] = j.items[h]; });
            if (!j.next) break;
          }
          if (Object.keys(out).length) guardarSesion(key, out); // nunca se guarda un resultado vacío
          else delete menus[key];
          return out;
        })().catch(function () { return {}; });
      }
    }
    menus[key].then(function (m) { Object.keys(m).forEach(function (h) { if (!cache[h]) cache[h] = Promise.resolve(m[h]); }); });
    return menus[key];
  };
  // Los cuatro menús juntos.
  N.todos = function () {
    return Promise.all([1, 2, 3, 4].map(N.menu)).then(function (list) {
      var out = {};
      list.forEach(function (m) { Object.keys(m).forEach(function (h) { out[h] = m[h]; }); });
      return out;
    });
  };
  N.tieneDatos = function (d) { return !!d && num(d.kcal) > 0; };

  // "Gluten, soya" → ['Gluten', 'Soya'] con el vocabulario de la web.
  N.alergenos = function (d) {
    if (!d || !d.alergenos) return [];
    var txt = Array.isArray(d.alergenos) ? d.alergenos.join(',') : String(d.alergenos);
    return txt.split(/[,;\/]| y /).map(plano).filter(Boolean).map(function (a) {
      return N.ALERGENOS.filter(function (v) { return plano(v) === a || a.indexOf(plano(v)) === 0; })[0] || (a.charAt(0).toUpperCase() + a.slice(1));
    }).filter(function (v, i, arr) { return arr.indexOf(v) === i; });
  };

  // Porcentajes: kcal sobre 2,000 al día; cada macro sobre las calorías que suman los tres.
  N.porcentajes = function (d) {
    var k = num(d.kcal) || 0, p = num(d.proteina) || 0, c = num(d.carbohidratos) || 0, g = num(d.grasa) || 0;
    var tot = p * 4 + c * 4 + g * 9 || 1;
    return { k: Math.round(k * 100 / KCAL_DIA), p: Math.round(p * 400 / tot), c: Math.round(c * 400 / tot), g: Math.round(g * 900 / tot) };
  };

  function aro(arc) {
    return '<svg class="ns-aro__svg" viewBox="0 0 36 36" aria-hidden="true" focusable="false"><circle class="ns-aro__pista" cx="18" cy="18" r="15.9155"/>' +
      '<circle class="ns-aro__valor" cx="18" cy="18" r="15.9155" pathLength="100" stroke-dasharray="' + Math.max(0, Math.min(100, arc)) + ' 100" transform="rotate(-90 18 18)"/></svg>';
  }
  // opt: { tamano: 'completo'|'compacto', tema: 'oscuro', proteinaSolo }
  N.aros = function (d, opt) {
    opt = opt || {};
    if (!N.tieneDatos(d)) return '';
    var t = opt.tamano || 'compacto', full = t === 'completo', pc = N.porcentajes(d);
    var item = function (cls, arc, numero, unidad, nombre, corto, pct) {
      return '<li class="ns-aro ns-aro--' + cls + '"><span class="ns-aro__fig">' + aro(arc) + '<span class="ns-aro__num">' + esc(numero) + (unidad ? '<small>' + unidad + '</small>' : '') + '</span></span>' +
        '<span class="ns-aro__txt"><span class="ns-aro__nombre">' + (full ? nombre : corto) + '</span>' + (full ? '<span class="ns-aro__pct">' + pct + '</span>' : '') + '</span></li>';
    };
    var h = '<ul class="ns-aros ns-aros--' + t + (opt.tema === 'oscuro' ? ' ns-aros--oscuro' : '') + '" aria-label="Información nutricional por porción">' +
      item('kcal', pc.k, fmtNum(d.kcal), '', 'kcal', 'kcal', pc.k + ' % del día*') +
      item('proteina', pc.p, fmtNum(d.proteina), 'g', 'Proteína', 'Prot.', pc.p + ' % kcal');
    if (!opt.proteinaSolo) {
      h += item('carbohidratos', pc.c, fmtNum(d.carbohidratos), 'g', '<span class="ns-aro__l">Carbohidratos</span><span class="ns-aro__s">Carbs</span>', 'Carbs', pc.c + ' % kcal') +
        item('grasa', pc.g, fmtNum(d.grasa), 'g', 'Grasa', 'Grasa', pc.g + ' % kcal');
    }
    h += '</ul>';
    if (full) {
      h += '<p class="ns-aros__nota">Por porción' + (num(d.gramos) ? ' de ' + fmtNum(d.gramos) + ' g' : '') + '. ' +
        'El anillo de cada macro es la parte de las calorías del platillo que aporta. *Con base en una dieta de 2,000 kcal.' +
        (d.estado !== 'Validado' ? ' Valores aproximados calculados de la receta.' : '') + '</p>';
    }
    return h;
  };
  function fmtNum(v) { var n = num(v); return n == null ? '–' : (Math.round(n * 10) / 10).toLocaleString('es-MX'); }
  N.fmt = fmt;

  function htmlVista(d) {
    var out = '<div class="ns-qv-nutri">';
    if (N.tieneDatos(d)) out += N.aros(d, { tamano: 'completo' });
    var al = N.alergenos(d);
    if (al.length) out += '<p class="ns-qv-nutri__alerg"><strong>Alérgenos:</strong> contiene ' + esc(al.join(', ').toLowerCase()) + '.</p>';
    else if (N.tieneDatos(d)) out += '<p class="ns-qv-nutri__alerg ns-qv-nutri__alerg--ok"><strong>Alérgenos:</strong> sin alérgenos declarados en la receta.</p>';
    return out + '</div>';
  }

  document.addEventListener('ns:quickview', function (e) {
    var el = e.detail && e.detail.el;
    var p = e.detail && e.detail.product;
    if (!el || !p || !p.handle) return;
    N.get(p.handle).then(function (d) {
      if (!d || (!N.tieneDatos(d) && !d.alergenos) || !el.isConnected || el.querySelector('.ns-qv-nutri')) return;
      var ancla = el.querySelector('.ns2-qv__action');
      if (ancla) ancla.insertAdjacentHTML('beforebegin', htmlVista(d));
    });
  });

  global.NSNutri = N;
})(typeof window !== 'undefined' ? window : globalThis);
